export const frontmatter = {
  title: "Team",
  order: 7,
}

The team is key to the creation, education, and adoption of our protocol. We have assembled a knowledgeable and dedicated team committed to the success of Scale.farm. Each member's skills have been selected to ensure our goals and objectives are met.

## CaptnHayz

> @CaptnHayz on Discord

## Zod

> @0xZod on Discord

Lead Dev

## Groot

> @0xGroot on Discord

## Arika

> Arika

## Gelat0x

> @gelatocrx.

## Sam

> @i543 on Discord

Lead Smart Contracts Dev
